import { input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "NotificationsApp/ts/features/background-jobs-progress-popover/components/background-jobs-progress-popover-item/background-jobs-progress-popover-item.component";
function BackgroundJobsProgressPopoverComponent_div_0_tr_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 12);
} if (rf & 2) {
    const progress_r3 = ctx.$implicit;
    i0.ɵɵproperty("progress", progress_r3.value);
} }
function BackgroundJobsProgressPopoverComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵelement(3, "div", 4);
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtext(5, "In Progress");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
    i0.ɵɵlistener("click", function BackgroundJobsProgressPopoverComponent_div_0_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 9)(10, "table", 10)(11, "tbody");
    i0.ɵɵtemplate(12, BackgroundJobsProgressPopoverComponent_div_0_tr_12_Template, 1, 1, "tr", 11);
    i0.ɵɵpipe(13, "keyvalue");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(13, 1, ctx_r1.jobsInProgress(), ctx_r1.progressOrdering));
} }
export class BackgroundJobsProgressPopoverComponent {
    constructor() {
        this.jobsInProgress = input({}, ...(ngDevMode ? [{ debugName: "jobsInProgress" }] : []));
        this.isOpen = false;
    }
    openModal() {
        this.isOpen = true;
    }
    closeModal() {
        this.isOpen = false;
    }
    progressOrdering(_left, _right) {
        // Maintain order that jobs were inserted into the jobsInProgress map
        return 0;
    }
}
BackgroundJobsProgressPopoverComponent.ɵfac = function BackgroundJobsProgressPopoverComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BackgroundJobsProgressPopoverComponent)(); };
BackgroundJobsProgressPopoverComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BackgroundJobsProgressPopoverComponent, selectors: [["ycn-background-jobs-progress-popover"]], inputs: { jobsInProgress: [1, "jobsInProgress"] }, standalone: false, decls: 1, vars: 1, consts: [["class", "notifications collapse show modal mt-1", "style", "top: auto; bottom: auto; left: auto; padding: unset", 4, "ngIf"], [1, "notifications", "collapse", "show", "modal", "mt-1", 2, "top", "auto", "bottom", "auto", "left", "auto", "padding", "unset"], [1, "notifications-header"], [1, "d-flex", "align-items-center"], [1, "circle-progress", "mr-1"], [1, "notifications-header-title"], [1, "notifications-header-options"], ["data-toggle", "collapse", "data-target", "notifications", 1, "btn", "btn-xs", "btn-circle", "btn-transparent2", 3, "click"], ["ycnIcon", "", "name", "icon-close"], [1, "overflow-auto"], [1, "table", "table-airy"], ["ycn-background-jobs-progress-popover-item", "", 3, "progress", 4, "ngFor", "ngForOf"], ["ycn-background-jobs-progress-popover-item", "", 3, "progress"]], template: function BackgroundJobsProgressPopoverComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, BackgroundJobsProgressPopoverComponent_div_0_Template, 14, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i2.IconDirective, i3.BackgroundJobsProgressPopoverItemComponent, i1.KeyValuePipe], encapsulation: 2 });
